import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from '../../components/Loading';
import { useMemo, useState } from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import SettingsSidebar from './components/SettingsSidebar';
import SettingsTabController from './components/SettingsTabController';
import { useSettingsPageDimensions } from '../../hooks/useSettingsPageDimensions';

function Settings() {
  const [tabSpinner, setTabSpinner] = useState(false);

  const settingsSidebar = useMemo(
    () => ({
      rules: { name: 'Rules' },
      'referral-campaigns': { name: 'Referral Campaigns' },
      'popup-messages': { name: 'Popup Messages' },
      rewards: { name: 'Rewards' },
      settings: {
        name: 'Settings',
        nested: {
          'banking-holidays': { name: 'Banking Holidays' },
          'global-settings': { name: 'Global Settings' },
        },
      },
      permissions: { name: 'Permissions' },
    }),
    [],
  );

  const {
    collapsed,
    setCollapsed,
    collapsedSize,
    minSidebarSize,
    defaultSidebarSize,
    maxSidebarSize,
    sidebarRef,
    expandSidebar,
  } = useSettingsPageDimensions();

  return (
    <div className="d-flex h-100">
      <PanelGroup direction="horizontal">
        <Panel
          ref={sidebarRef}
          collapsible
          collapsedSize={collapsedSize}
          minSize={minSidebarSize}
          defaultSize={defaultSidebarSize}
          maxSize={maxSidebarSize}
          onCollapse={() => setCollapsed(true)}
          onExpand={() => setCollapsed(false)}
          className="d-flex flex-column"
        >
          <SettingsSidebar
            settingsSidebar={settingsSidebar}
            collapsed={collapsed}
            expandSidebar={expandSidebar}
          />
        </Panel>
        <PanelResizeHandle className="bo-common-resize-handle-vertical" />
        <Panel className="d-flex flex-column">
          <SettingsTabController
            settingsSidebar={settingsSidebar}
            tabSpinner={tabSpinner}
            setTabSpinner={setTabSpinner}
          />
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default withAuthenticationRequired(Settings, { onRedirecting: () => <Loading /> });
